import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';



//港口列表
export async function getSeaPorts(params) {
    return post(oaserver+'/dict/seaport/getSeaPorts', params, true);
}
//港口新增
export async function addSeaPort(params) {
    return post(oaserver+'/dict/seaport/addSeaPort', params, true);
}
//港口编辑
export async function editSeaPort(params) {
    return post(oaserver+'/dict/seaport/editSeaPort', params, true);
}
//国家
export async function getAreaByLevel(params) {
    return post(oaserver+'/dict/area/getAreaByLevel', params, true);
}
//区域树
export async function getAreaTree(params) {
    return post(oaserver+'/dict/area/getAreaTree', params, true);
}